import {
  EVOLUTION_EDIT_WINDOW_MS,
  isEvolutionAdminRole,
  isEvolutionInvalidated,
  isEvolutionSigned,
  type EvolutionRecord,
  type EvolutionViewer,
} from './evolutionRecordPolicy';

export type EvolutionAdditionAttachmentDoc = {
  id: string;
  title?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  file_type?: string | null;
};

export type EvolutionAdditionAttachmentImage = {
  id: string;
  title?: string | null;
  file_name?: string | null;
  file_url?: string | null;
  file_type?: string | null;
};

export type EvolutionAddition = {
  id: string;
  professional_id?: string | null;
  professional?: { id?: string; full_name?: string | null } | null;
  body_html?: string;
  added_at?: string;
  created_at?: string;
  documents?: EvolutionAdditionAttachmentDoc[] | null;
  images?: EvolutionAdditionAttachmentImage[] | null;
};

export function canAddEvolutionAddition(
  viewer?: EvolutionViewer | null,
  evo?: EvolutionRecord | null,
): boolean {
  if (!viewer?.professional_id || !evo || isEvolutionInvalidated(evo)) return false;
  return isEvolutionSigned(evo);
}

export function canEditEvolutionAddition(
  viewer?: EvolutionViewer | null,
  addition?: EvolutionAddition | null,
  now = Date.now(),
): boolean {
  if (!addition) return false;
  if (isEvolutionAdminRole(viewer?.role)) return true;
  const authorId = addition.professional_id || addition.professional?.id;
  if (!viewer?.professional_id || !authorId || viewer.professional_id !== authorId) return false;
  const t = addition.created_at ? new Date(addition.created_at).getTime() : NaN;
  if (Number.isNaN(t)) return false;
  return now - t <= EVOLUTION_EDIT_WINDOW_MS;
}

export function formatEvolutionAdditionDate(addedAt?: string | null): string {
  if (!addedAt) return '';
  const d = new Date(addedAt);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
